import CampaignSettings from './CampaignSettings.vue'

export default CampaignSettings
